<form nz-form (ngSubmit)="submitForm()">
  <nz-form-item class="hidden">
    <nz-form-control [nzSpan]="12">
      <input
        nz-input
        [(ngModel)]="shortname"
        name="shortname"
        type="text"
        id="shortname"
        disabled
      />
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label [nzSpan]="4" nzFor="label" nzRequired>Label</nz-form-label>
    <nz-form-control [nzSpan]="12">
      <input nz-input [(ngModel)]="label" name="label" type="text" id="label" />
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label [nzSpan]="4" nzFor="url" nzRequired>URL</nz-form-label>
    <nz-form-control [nzSpan]="12">
      <input nz-input [(ngModel)]="url" name="url" type="text" id="url" />
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label [nzSpan]="4" nzFor="accessedBy" nzRequired>Roles</nz-form-label>
    <nz-form-control [nzSpan]="12">
      <nz-select
        [(ngModel)]="accessedBy"
        name="accessedBy"
        nzMode="multiple"
        nzPlaceHolder="Please select which roles you want to have access as"
        id="accessedBy"
      >
        <nz-option
          *ngFor="let item of listOfOptions; trackBy: trackByRef"
          [nzLabel]="item"
          [nzValue]="item"
        ></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-control [nzOffset]="5" [nzSpan]="8">
      <button nz-button nzType="primary" [nzLoading]="isSaving" [disabled]="isSaving">
        Submit
      </button>
    </nz-form-control>
  </nz-form-item>
</form>
